<template>
  <div class="profil-container">
    <h3 class="profil-title">
      Selamat Datang di Halaman Pengisian dan Unggah Dokumen Prakualifikasi SMKPLH Sinarmas Mining
    </h3>
    <div class="instruction-wrapper">
      <div class="instruction-list">
        <div class="instruction-number">1.</div>
        <div class="instruction-text">
          Mohon untuk mengisi data selengkap mungkin demi mempermudah untuk
          lolos sebagai calon vendor
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">2.</div>
        <div class="instruction-text">
          Anda wajib mengisi pertanyaan yang bertanda (<span style="color:red"
            >*</span
          >)
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">3.</div>
        <div class="instruction-text">
          Sesuai dengan Undang-Undang 11 tahun 2020 tentang Cipta Kerja dan
          peraturan KKPM nomor 3 tahun 2021 tentang sistem perizinan berusaha
          berbasis resiko terintegrasi secara elektronik maka dari itu badan
          usaha wajib memiliki NIB untuk pendaftaran sebagai calon vendor
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">4.</div>
        <div class="instruction-text">
          Jika memerlukan bantuan atau penjelasan tentang persyaratan tertentu,
          silahkan hubungi Dept. SIPM
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">5.</div>
        <div class="instruction-text">
          Silahkan isi pertanyaan dengan kategori sebagai berikut: <br />
          Apabila kegiatan usaha Kritis maka isi dengan kategori Kritis, Tinggi,
          Sedang dan Rendah<br />
          Apabila kegiatan usaha Tinggi maka isi dengan kategori Tinggi, Sedang,
          dan Rendah<br />
          Apabila kegiatan usaha Sedang maka isi dengan kategori Sedang, dan
          Rendah<br />
          Apabila kegiatan usaha Rendah maka isi dengan kategori Rendah
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">6.</div>
        <div class="instruction-text">
          Catatan Penilaian: <br />
          N/A: Tidak diperlukan<br />
          0: Tidak ada / tidak tersedia / tidak dijelaskan<br />
          1: Persyaratan belum terpenuhi<br />
          2: Persyaratan cukup memadai tetapi perlu perbaikan<br />
          3: Persyaratan sudah memadai<br />
        </div>
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goNext()" class="btn-landing">Selanjutnya</div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goNext() {
      this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'profile' })
    },
  },
}
</script>
